import React, { FC } from 'react';

import { ImageProps } from './types';

export const Image: FC<ImageProps> = ({ loading = 'lazy' as const, alt = '', ...restProps }) => (
  <img alt={alt} loading={loading} {...restProps} />
);
